<footer *ngIf="(isLoggedIn$ | async)">
  <div class="container mx-auto py-2">
    &copy; 2021 Entrada.
  </div>
</footer>
